var app = angular.module('leonardo');

var MakeReady = function (
  $scope,
  $state,
  $element,
  $rootScope,
  $q,
  $timeout,
  ngDialog,
  FilterService,
  ConfigThemeService,
  TaskService,
  DynamicFormRestService,
  DynamicFormDataRestService,
  PropertyService,
  NoteService,
  TemplateWorkflowService,
  AccountUserService,
  PermissionService,
  AnalyticsService
) {
  $scope.MRB_element = $element.find('#react-make-ready')[0];

  $scope.params = $state.params;

  $scope.showAction = function (action, task, moveInDate, actionItems) {
    TaskService.get(task.id).then(function (result) {
      switch (action) {
        case 'play':
          $scope.playTask(result);
          break;
        case 'pause':
          $scope.pauseTask(result);
          break;
        case 'notes':
          $scope.showNoteDialog(result);
          break;
        case 'addNotes':
          $scope.showAddNoteDialog(result);
          break;
        case 'taskDetail':
          $scope.showDetailDialog(result);
          break;
        case 'attachments':
          $scope.showAttachmentDialog(result);
          break;
        case 'assign':
          $scope.showAssignDialog(result);
          break;
        case 'user':
          $scope.showUsersDialog(result);
          break;
        case 'resolve':
          $scope.showDynamicAndResolve(result);
          break;
        case 'cannot':
          $scope.showCannotDoDialog(result);
          break;
        case 'unComplete':
          $scope.showUnCompleteDialog(result);
          break;
        case 'toReview':
          $scope.goToReview(result);
          break;
        case 'changeDate': 
          $scope.showChangeDateDialog(result, task, moveInDate, actionItems);
          break;
      }
    });
  };
  $scope.goToReview = function (task) {
    $state.go('property.tasks.approval', { pk: task.id, is_mrb: true });
  };

  $scope.showResolveDialog = function (task) {
    AnalyticsService.track('Task Opened', {
      context: 'make-ready tasks',
      destination: 'complete',
      entry_method: 'click',
      ...AnalyticsService.getTaskGroupProperties(task)});
    var filters = {};
    if (
      !isNull(task.status) &&
      [TaskService.STATUS_APPROVAL_IN_PROGRESS, TaskService.STATUS_APPROVAL_APPROVED, TaskService.STATUS_APPROVAL_REJECTED].includes(
        task.status.toString()
      )
    ) {
      filters.for_approval = true;
    }
    TaskService.one(task.id)
      .get(filters)
      .then(function (result) {
        var promises = [];
        var notes = [];
        collectNotes(task, promises, notes);
        $q.all(promises).then(function () {
          const newTask = angular.copy(result);
          newTask.notes = notes;
          if (newTask.has_approval_config && ![TaskService.STATUS_APPROVAL_APPROVED].includes(newTask.status.toString())) {
            TaskService.getSequenceApprovers(newTask.id).then(function (conflicts) {
              if (!isEmpty(conflicts.results)) {
                ngDialog
                  .openConfirm({
                    template: 'views/templates/dialog/task/resolve-conflicts.html',
                    controller: 'TaskResolveConflictsDialog',
                    data: {
                      task: newTask,
                      conflicts: conflicts.results
                    }
                  })
                  .then(function (data) {
                    ngDialog.open({
                      template: 'views/templates/dialog/task/request-approval.html',
                      controller: 'TaskResolveDialog',
                      data: {
                        task: newTask,
                        fallback_approvers: data,
                        is_mrb: true
                      }
                    });
                  });
              } else {
                ngDialog.open({
                  template: 'views/templates/dialog/task/request-approval.html',
                  controller: 'TaskResolveDialog',
                  data: {
                    task: newTask,
                    is_mrb: true
                  }
                });
              }
            });
          } else {
            ngDialog.open({
              template: 'views/templates/dialog/task/resolve.html',
              controller: 'TaskResolveDialog',
              data: {
                task: newTask,
                is_mrb: true
              }
            });
          }
        });
      });
  };

  $scope.showDynamicAndResolve = function (task) {
    if (task.dynamic_form) {
      $scope.openDynamicFormDialog(
        task,
        function (result) {
          var filters = {};
          if (
            !isNull(task.status) &&
            [
              TaskService.STATUS_APPROVAL_IN_PROGRESS,
              TaskService.STATUS_APPROVAL_APPROVED,
              TaskService.STATUS_APPROVAL_REJECTED,
              TaskService.STATUS_APPROVAL_RETURN_SUBMITTER
            ].includes(task.status.toString())
          ) {
            filters.for_approval = true;
          }
          var data = result.dynamic_form_data ? result.dynamic_form_data : result;
          var action_item = result.task ? TaskService.one(result.task).get(filters) : task;
          $q.when(action_item).then(function (res) {
            if (data !== 'skip') {
              task.dynamic_form_data = data.id ? data.id : data;
              if (!data.progress) {
                $scope.showResolveDialog(res);
              }
            } else {
              $scope.showResolveDialog(res);
            }
          });
        },
        true
      );
    } else {
      $scope.showResolveDialog(task);
    }
  };

  $scope.openDynamicFormDialog = function (task, callback, showSkipButton) {
    PropertyService.get(task.property).then(function (property) {
      if (task.dynamic_form_data && task.dynamic_form_data !== 'skip') {
        const data_id = task.dynamic_form_data.id ? task.dynamic_form_data.id : task.dynamic_form_data;
        DynamicFormDataRestService.get(data_id).then(function (data) {
          ngDialog
            .openConfirm({
              template: 'views/templates/dialog/task/dynamic-form-react.html',
              className: 'ngdialog-theme-default ngdialog-dynamic-form',
              controller: 'TaskDynamicFormDialogReact',
              resolve: {
                formObj: [
                  function () {
                    return data.dynamic_form;
                  }
                ],
                formDataObj: [
                  function () {
                    return data;
                  }
                ]
              },
              data: {
                task: task,
                approvalStatus: [TaskService.STATUS_APPROVAL_IN_PROGRESS].includes(task.status.toString()),
                property: property,
                showSkip: showSkipButton
              }
            })
            .then(
              function (result) {
                $rootScope.$broadcast('task-dynamic-form-data:updated', task);
                callback(result);
              },
              function () {
                handleError();
              }
            );
        });
      } else {
        DynamicFormRestService.get(task.dynamic_form.id).then(function (data) {
          ngDialog
            .openConfirm({
              template: 'views/templates/dialog/task/dynamic-form-react.html',
              className: 'ngdialog-theme-default ngdialog-dynamic-form',
              controller: 'TaskDynamicFormDialogReact',
              resolve: {
                formObj: [
                  function () {
                    return data;
                  }
                ],
                formDataObj: [
                  function () {
                    return null;
                  }
                ]
              },
              data: {
                task: task,
                approvalStatus: [TaskService.STATUS_APPROVAL_IN_PROGRESS].includes(task.status.toString()),
                property: property,
                showSkip: showSkipButton
              }
            })
            .then(
              function (result) {
                $rootScope.$broadcast('task-dynamic-form-data:updated', task);
                callback(result);
              },
              function () {
                handleError();
              }
            );
        });
      }
      function handleError(){
        if (task?.workflow_instance) {
          $rootScope.$broadcast('close-unit-dynamic-form');
        } else {
          $rootScope.$broadcast('task-dynamic-form-data:updated', task);
        }
      }
    });
  };

  $scope.showDetailDialog = function (task) {
    AnalyticsService.track('Task Opened', {
          context: 'make-ready tasks',
          destination: 'detail',
          entry_method: 'click',
          ...AnalyticsService.getTaskGroupProperties(task)});
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/task/detail.html',
        controller: 'TaskDetailDialog',
        data: {
          task: task,
          mode: 'review'
        }
      })
      .then(function (data) {
        if (data === 'resolve') {
          $scope.showDynamicAndResolve(task);
        }
      });
  };

  $scope.showAttachmentDialog = function (task) {
    ngDialog.open({
      template: 'views/templates/dialog/attachment/list.html',
      controller: 'AttachmentListDialog',
      className: 'ngdialog-theme-default ngdialog-attachments-view',
      data: {
        attachments: task.attachments
      }
    });
  };

  $scope.showUsersDialog = function (task) {
    ngDialog.open({
      template: 'views/templates/dialog/task/users.html',
      controller: 'TaskUsersDialog',
      data: {
        task: task
      }
    });
  };

  function collectNotes(task, promises, notes){
    angular.forEach(task.notes, function (note) {
      if (note.id) {
        promises.push(notes.push(note));
      } else {
        promises.push(
          NoteService.get(note, true).then(function (data) {
            notes.push(data);
          })
        );
      }
    });
  }

  $scope.showNoteDialog = function (task) {
    const promises = [];
    const notes = [];
    collectNotes(task, promises, notes);
    $q.all(promises).then(function () {
      const newTask = angular.copy(task);
      newTask.notes = notes;
      ngDialog
        .openConfirm({
          template: 'views/templates/dialog/task/note.html',
          controller: 'TaskNoteDialog',
          data: {
            task: newTask
          }
        })
        .then(function (data) {
          task.notes = data.notes;
        });
    });
  };

  $scope.showAddNoteDialog = function (task) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/task/add-note.html',
        controller: 'TaskAddNoteDialog',
        data: {
          task: task
        }
      })
      .then(function (data) {
        task.notes.push(data.id);
        $rootScope.$broadcast('task-notes:updated', task);
      });
  };

  $scope.showChangeDateDialog = function (task, taskInfo, moveInDate, actionItems) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/task/change-date.html',
        controller: 'ChangeDateDialog',
        data: {
          task: task,
          taskInfo: taskInfo,
          moveInDate: moveInDate,
          actionItems: actionItems,
        }
      })
  };

  $scope.showAssignDialog = function (task) {
    TemplateWorkflowService.get(task.template).then(function (data) {
      ngDialog
        .openConfirm({
          template: 'views/templates/dialog/task/assign.html',
          controller: 'TaskAssignDialog',
          resolve: {
            accountUsers: function () {
              let filters = {
                disable_pagination: true,
                essential: true,
                user_is_active: true
              };
              if (!isEmpty(task.roles)) {
                filters['role'] = task.roles.join(',');
              }
              if (task.property) {
                filters['property'] = task.property;
              } else if (task.portfolio) {
                filters['portfolio'] = task.portfolios;
              } else if (task.account) {
                filters['account'] = task.account;
              }
              return AccountUserService.getAvailableToAssign(filters);
            }
          },
          data: {
            task: task,
            template: data
          }
        })
        .then(function (result) {
          if (result) {
            task = result;
            $rootScope.$broadcast('task-assign-user:updated', task);
          } else {
            $rootScope.$broadcast('template:updated', task);
          }
        });
    });
  };

  $scope.showCannotDoDialog = function (task) {
    AnalyticsService.track('Task Opened', {
      context: 'make-ready tasks',
      destination: 'cannot do',
      entry_method: 'click',
      ...AnalyticsService.getTaskGroupProperties(task)});
    ngDialog.open({
      template: 'views/templates/dialog/task/cannot-do.html',
      controller: 'TaskCannotDoDialog',
      data: {
        task: task,
        is_mrb: true
      }
    });
  };

  $scope.showUnCompleteDialog = function (task) {
    ngDialog.open({
      template: 'views/templates/dialog/task/uncomplete.html',
      controller: 'TaskUnCompleteDialog',
      data: {
        task: task
      }
    });
  };

  $scope.playTask = function (task) {
    task.play().then(function (data) {
      task.workflow_status = data.workflow_status;
      $rootScope.$broadcast('task-workflow-status:updated', data);
    });
  };

  $scope.pauseTask = function (task) {
    task.pause().then(function (data) {
      task.workflow_status = data.workflow_status;
      $rootScope.$broadcast('task-workflow-status:updated', data);
    });
  };

  $scope.removeReact = function () {
    if (!$scope.MRB_element) {
      return;
    }
    ReactDOM.unmountComponentAtNode(document.getElementById('react-make-ready'));
  };

  $scope.changeTrigger = function (range, page, flipToggle) {
    if (flipToggle) {
      $state.go('unit-turn.make-ready.table', { range: range, page: page, trigger: flipToggle });
    } else {
      $state.go('unit-turn.make-ready', { range: range, page: page, trigger: flipToggle });
    }
  };

  $scope.checkPermission = function (...permissions) {
    if(PermissionService.isAccountOwner() && PermissionService.permissionAvailableAccount('permission_view_make_ready_board')) {
      return true;
    }
    else {
      return (PermissionService.permissionAvailableAccount('permission_view_make_ready_board') && PermissionService.permissionAvailable(permissions));
    }
  };
  $scope.loadReact = function () {
    if ($state.current.url == '/table') {
      $scope.params.trigger = true;
    }

    let filters = {
      property: FilterService.getFilter('property'),
      workflow_turn_type: FilterService.getFilter('workflow_type'),
      workflow: FilterService.getFilter('workflow'),
      building: FilterService.getFilter('building_number'),
      unit_type: FilterService.getFilter('unit_type'),
      on_notice: (typeof(FilterService.getFilter('units_on_notice')) != 'undefined' && FilterService.getFilter('units_on_notice')) ? true : undefined
    };
    if(FilterService.getFilter('overdue_units') && FilterService.getFilter('overdue_units') == 1) {
      filters['overdue_days'] = 5;
    }
    else if(FilterService.getFilter('overdue_units')  && FilterService.getFilter('overdue_units') == 2){
      filters['overdue_days_below'] = 5;
    }

    if ($scope.params.trigger) {
      filters = {
        ...filters,
        turn_status: FilterService.getFilter('unit_status'),
        name: FilterService.getFilter('workflow_name')
      };
    } else {
      filters = {
        ...filters,
        mrb_status: FilterService.getFilter('mrb_status'),
        ai_name: FilterService.getFilter('task_name'),
        roles: FilterService.getFilter('role')
      };
    }

    if ($scope.MRB_element) {
      ReactDOM.render(
        React.createElement(window.MakeReadyBoard, {
          configTheme: { config: ConfigThemeService.config, updated: ConfigThemeService.updated },
          range: $scope.params.range,
          page: $scope.params.page,
          flipToggle: $scope.params.trigger,
          filters: filters,
          onAction: $scope.showAction,
          onTrigger: $scope.changeTrigger,
          hasPermission: $scope.checkPermission
        }),
        $scope.MRB_element
      );
    }
  };

  $timeout($scope.loadReact, 100);

  $scope.$on('$destroy', function () {
    $scope.removeReact();
  });

  $scope.$on('filter-selection:updated', $scope.loadReact);

  $scope.$on('task-resolve-dialog:success', $scope.loadReact);

  $scope.$on('task-request-approval-dialog:success', $scope.loadReact);

  $scope.$on('task-cannot-do-dialog:success', $scope.loadReact);

  $scope.$on('task-assign-user:updated', $scope.loadReact);

  $scope.$on('task-notes:updated', $scope.loadReact);

  $scope.$on('task-recurrence-dialog:success', $scope.loadReact);

  $scope.$on('task-priority-dialog:success', $scope.loadReact);

  $scope.$on('task-deactivate-dialog:success', $scope.loadReact);

  $scope.$on('task-un-resolve-dialog:success', $scope.loadReact);

  $scope.$on('task-snooze-dialog:success', $scope.loadReact);

  $scope.$on('task-workflow-status:updated', $scope.loadReact);

  $scope.$on('task-dynamic-form-data:updated', $scope.loadReact);

  $scope.$on('close-unit-dynamic-form', $scope.loadReact);

  $scope.$on('workflow-tasks:updated', $scope.loadReact);

  $scope.$on('task-change-date-dialog:success', $scope.loadReact);
};

app.controller('MakeReady', [
  '$scope',
  '$state',
  '$element',
  '$rootScope',
  '$q',
  '$timeout',
  'ngDialog',
  'FilterService',
  'ConfigThemeService',
  'TaskService',
  'DynamicFormRestService',
  'DynamicFormDataRestService',
  'PropertyService',
  'NoteService',
  'TemplateWorkflowService',
  'AccountUserService',
  'PermissionService',
  'AnalyticsService',
  MakeReady
]);
